import { apis, serviceInterface } from "./config";

export const getMe = () => {
  return serviceInterface.get(`${apis.ME}`);
};
